<template>
  <el-col :span="12">
    <el-card class="box-card">
      <h2>Actions:</h2>
      <el-select
        v-model="actionSelected"
        :disabled="!isItemsSelectedEmpty"
        clearable
        :placeholder="!isItemsSelectedEmpty ? 'Select a PO' : 'Select an action'"
        @change="exportPO">
        <el-option-group
          v-for="group in selectActionOptions"
          :label="group.label"
          :key="group.label">
          <el-option
            v-for="item in group.options"
            :label="item.label"
            :value="item.value"
            :key="item.value">
          </el-option>
        </el-option-group>
      </el-select>
    </el-card>
  </el-col>
</template>

<script>

export default {
  data() {
    return {
      itemsSelected: [],
      selectActionOptions: [{
        label: 'Export as',
        options: [{
          value: 'xlsx',
          label: 'Excel',
        }],
      }],
      actionSelected: [],
    };
  },
  computed: {
    getItemsSelected() {
      const poItemsSelected = this.$store.getters.getPoItemsSelected;
      this.setItemsSelected(poItemsSelected);
      return this.itemsSelected;
    },
    isItemsSelectedEmpty() {
      return this.getItemsSelected.length > 0;
    },
  },
  methods: {
    setItemsSelected(i) {
      this.itemsSelected = i;
    },
    exportPO() {
      // if (this.actionSelected.length > 0) {
      //   console.log('export ' + this.getItemsSelected +  ' as ' + this.actionSelected);
      // }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-card {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/payments/partials/PaymentsListActions.vue